<template>
  <section class="home-new-section my-pension">
    <div class="container">
      <div class="layout">
        <div class="section-inner">
          <div class="text-center">
            <h1 class="heading-with-underline">All at your fingertips</h1>
          </div>
          <div class="flex content-wrapper">
            <div class="content-left">
              <div class="content-left--inner">
                <div class="list">
                  <div class="list-item flex">
                    <div class="bullet">
                      <div class="circle"><font-awesome-icon :icon="['fal', 'check']"></font-awesome-icon></div>
                    </div>
                    <span class="list-item--text" :class="{ 'active-slide': activeIndex === 0 }">Access your personal correspondence</span>
                  </div>
                  <div class="list-item flex">
                    <div class="bullet">
                      <div class="circle"><font-awesome-icon :icon="['fal', 'check']"></font-awesome-icon></div>
                    </div>
                    <span class="list-item--text" :class="{ 'active-slide': activeIndex === 1 }">Update your information</span>
                  </div>
                  <div class="list-item flex">
                    <div class="bullet">
                      <div class="circle"><font-awesome-icon :icon="['fal', 'check']"></font-awesome-icon></div>
                    </div>
                    <span class="list-item--text" :class="{ 'active-slide': activeIndex === 2 }">Complete forms online</span>
                  </div>
                  <div class="list-item flex" v-if="showModellerBenefits">
                    <div class="bullet">
                      <div class="circle"><font-awesome-icon :icon="['fal', 'check']"></font-awesome-icon></div>
                    </div>
                    <span class="list-item--text" :class="{ 'active-slide': activeIndex === 3 }">View your benefits in the {{clientConfig.fundOrScheme}}, which may include your options at retirement and a current transfer value illustration <span v-if="modellerComingSoon">(coming soon)</span></span>
                  </div>
                    <div class="list-item flex" v-if="showPensionPaySlip">
                      <div class="bullet">
                        <div class="circle"><font-awesome-icon :icon="['fal', 'check']"></font-awesome-icon></div>
                      </div>
                      <span class="list-item--text" :class="{ 'active-slide': activeIndex === 4 }">Find your pension payslips <span v-if="modellerComingSoon">(coming soon)</span></span>
                    </div>
                </div>

                <button class="button-solid-rounded pension" @click="$router.push('/my-pension/my-data')" v-if="!isRegistrationAndLoginDisabled">
                  My Pension <span class="button-icon"><font-awesome-icon :icon="['fal', 'lock']"></font-awesome-icon></span>
                </button>
              </div>
            </div>
            <div class="content-right">
              <div class="content-right--inner home-card-shadow">
                <MyPensionSwiper @setSliderIndex="setSliderIndex" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MyPensionSwiper from '@/components/newHomepage/MyPensionSwiper.vue';

export default {
    name: 'my-pension',
    components: {
        MyPensionSwiper,
    },
    data () {
        return {
            activeIndex: 0,
        };
    },

    computed: {
        modellerComingSoon () {
            return this.$store.state.clientConfig.modellerComingSoon;
        },
        clientConfig () {
            return this.$store.state.clientConfig;
        },
        showPensionPaySlip () {
            // Novuna fix - remove reference to payslips
            if (this.clientConfig.newHomepage.hiddenSections && Array.isArray(this.clientConfig.newHomepage.hiddenSections)) {
                return !this.clientConfig.newHomepage.hiddenSections.includes('pensionPayslip');
            }
            return true;
        },
        showModellerBenefits () {
            if (this.clientConfig.newHomepage.hiddenSections && Array.isArray(this.clientConfig.newHomepage.hiddenSections)) {
                return !this.clientConfig.newHomepage.hiddenSections.includes('modellerBenefits');
            }
            return true;
        },
        isRegistrationAndLoginDisabled () {
            return !!this.clientConfig.disableRegistrationAndLogin;
        },
    },

    methods: {
        setSliderIndex (index) {
            this.activeIndex = index;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';
.my-pension {
  position: relative;
  height: 40rem;
  @include responsive('mdLandscape') {
    height: 35rem;
  }
  @include responsive('md') {
    height: 57rem;
  }
  @include responsive('sm') {
    height: 53rem;
  }
  h1 {
    margin-bottom: 5rem;
    @include responsive('md') {
      margin-bottom: 4rem;
    }
    @include responsive('sm') {
      margin-bottom: 3rem;
    }
  }
  .content-wrapper {
    @include responsive('md') {
      flex-direction: column;
    }
  }
  .content {

    &-left {
      padding-right: 30px;
      order: 0;
      width: 45%;
      @include responsive('mdLandscape') {
        font-size: 0.8rem;
      }
      @include responsive('md') {
        width: 100%;
        order: 1;
        font-size: 0.9rem;
      }
      &--inner {
        @include responsive('md') {
          display: flex;
          flex-direction: column;
        }
        .pension {
          @include responsive('md') {
            width: 30%;
            align-self: center;
          }

          @include responsive("sm") {
            width: auto;
          }
        }
        .list {
          padding-top: 2rem;
          margin-bottom: 3rem;
          @include responsive('mdLandscape') {
            margin-bottom: 3rem;
          }
          @include responsive('md') {
            display: flex;
            flex-wrap: wrap;
          }
          &-item {
            align-items: flex-start;
            margin-bottom: 1rem;
            @include responsive('md') {
              flex: 1 0 50%;
            }
            @include responsive('sm') {
              flex: 1 0 100%;
            }
            .bullet {
              flex-shrink: 0;
              padding-top: 0.3rem;
              color: #ffffff;
              font-size: 0.7rem;
              font-weight: 800;
              .circle {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 1rem;
                height: 1rem;

                margin-right: 0.5rem;
                background-color: var(--primaryColour);
                border-radius: 50%;
              }
            }
            &--text {
              display: inline;
              vertical-align: top;
            }
          }
        }
      }
    }
    &-right {
      padding-left: 1rem;
      order: 1;
      width: 55%;
      @include responsive('md') {
        margin-top: 2rem;
        width: 100%;
        height: 25rem;
        padding-left: 0;
        order: 0;
      }
      @include responsive('sm') {
        height: 13rem;

      }
      &--inner {
        position: relative;
        background-color: white;
        //  width: 100%;
        height: 100%;
        padding: 0.5rem;
        border-radius: 0.5rem;
      }
    }
  }
}

button {
  background-color: var(--primaryColour);
  color: white;
}

.button-outline-rounded {
  border: 2px solid var(---primaryColour);
  // color: var(--textOnSecondary);
  // background: var(--secondaryColour);
  padding: 10px 40px;
  // text-transform: uppercase;
  display: inline-block;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &.small {
    padding: 5px 20px;
    border-radius: 30px;
  }
  span {
    display: inline-block;
    transition: $generalTransition;
  }
  &:hover {
    background: var(--primaryColour);
    opacity: 0.8;
    color: var(--textOnSecondary);
    span {
      transform: translateX(3px);
    }
    .back {
      transform: translateX(-3px) !important;
    }
  }
}
.active-slide {
  font-weight: 800;
}
</style>
